module.exports = __webpack_public_path__ + "img/clientelestate.be906b56.svg";